import React from 'react'
import { entryPointId } from '../../settings/app/constants'
const ResultTileContext = React.createContext({})

/**
 * data provider
 * case: hospitals => sorting data
 * @param values
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
export const ResultTileProvider = ({ values = {}, children }) => {
  // inspect data cases and append sorting for hospital tiles
  if (values.type === entryPointId.HOSPITALS) {
    const {
      is_treatment_reason,
      is_aop,
      qsrIdentifier,
      searchKey,
      singleQSRIndicator,
      result,
      currentSort,
    } = values

    try {
      // single qsr indicators will only show for a few searchKeys
      const isSingleQSRIndicator = singleQSRIndicator.includes(searchKey)

      // if a search was performed with treatment reason
      const isTreatmentReason = is_treatment_reason

      // special hits case: ambulant operation p.....
      const isAOP = is_aop && result?.treatment?.cases > 0

      // search has treatment reason but results did not have qsr data
      const isTreatmentReasonNoQsr =
        isTreatmentReason && !isAOP && qsrIdentifier.length === 0

      // search has treatment reason and results did have qsr data
      const isTreatmentReasonWithQsr =
        !isAOP &&
        isTreatmentReason &&
        result?.treatment?.cases &&
        qsrIdentifier.length > 0

      values.sorting = {
        isSingleQSRIndicator,
        isTreatmentReason,
        isAOP,
        isTreatmentReasonNoQsr,
        isTreatmentReasonWithQsr,
      }

      values.qsrHelper = {
        // return all qsr object which are not rendered at the accordion title
        getExcludedResultQsrBySortingKey: () => {
          const qsrArr = result.qsr.filter(
            (qsr) => qsr.identifier !== currentSort.replace('qsr_', '')
          )
          return qsrArr.length > 0 ? qsrArr : false
        },
        // return a qsr object for tile, which is not part of the current result tile (noQsr case)
        getMissingResultQsrBySort: () => {
          const qsrArr = qsrIdentifier.filter(
            (qsr) => qsr.identifier === currentSort.replace('qsr_', '')
          )
          return qsrArr.length > 0 ? qsrArr : false
        },
        // return current qsr data depending on selected qsr sort
        getResultQsrBySortingKey: () => {
          const qsrArr = result.qsr.filter(
            (qsr) => qsr.identifier === currentSort.replace('qsr_', '')
          )
          return qsrArr.length > 0 ? qsrArr : false
        },
      }
    } catch (e) {
      throw new Error(
        `Unable to parse tile data for sorting flags. Message: ${ e }`
      )
    }

    // TBD delete not required sorting props
    // => singleIndicators for example (ABS2 / CD UPDATE TASK)
  }

  if (values.type === entryPointId.CARESERVICES) {
    if (values.result.parentId !== null) {
      values.result.id = values.result.parentId
    }
  }

  return (
    <ResultTileContext.Provider value={ values }>
      {children}
    </ResultTileContext.Provider>
  )
}

export const useResultTileContext = () => {
  const context = React.useContext(ResultTileContext)
  if (context === undefined) {
    throw new Error(
      'useResultTileContext must be used within a ResultTileProvider'
    )
  }
  return context
}
